@if(personDetails(); as personDetails) {
<h5 class="text-center">{{personDetails.fullName}}</h5>

<div class="row">
	<div class="col-lg-6 mb-4">
		<table class='pro-table pro-table-no-background pro-table-with-labels pro-table-without-border'>
			<tr>
				<td>First Name</td>
				<td>{{personDetails.firstName}}</td>
			</tr>
			<tr>
				<td>Last Name</td>
				<td>{{personDetails.lastName}}</td>
			</tr>
			<tr>
				<td>Address</td>
				<td>
					@if(addressLinks(); as link) {
					<link-button [link]="link" />
					}
					@else {
					N/A
					}
				</td>
			</tr>
			<tr>
				<td>Phone</td>
				<td>
					@if(phoneLink(); as link) {
					<link-button [link]="link" />
					}
					@else {
					N/A
					}
				</td>
			</tr>
			<tr>
				<td>Emails</td>
				<td>
					@for(emailLink of emailLinks(); track $index) {
					<div class="d-flex align-items-center gap-1 my-1">
						<link-button [link]="emailLink.link" />
						@if(emailLink.isDefault){
						<span>(Primary)</span>
						}
					</div>
					}
				</td>
			</tr>

		</table>
	</div>
	<div class="col-lg-6 mb-4">
		<p>Default contact method: {{personDetails.contactMethodName}}</p>
		<common-button-row>
			<button class="btn btn-standard" (click)="sendEmail(personDetails.emails)">
				<i class="fa-regular fa-envelope"></i> Email
			</button>
			<button class="btn btn-standard" (click)="sendText(personDetails.phone!)">
				<i class="fa-regular fa-phone"></i> Contact
			</button>
			<button class="btn btn-standard" (click)="sendText(personDetails.phone!)">
				<i class="fa-regular fa-comment"></i> SMS
			</button>
		</common-button-row>
	</div>
</div>



}